import { Icon } from "../Icon";

type CheckToggleProps = {
  checked: boolean;
  label: string;
  onChange?: (checked: boolean) => void;
  /** Sottofonte in errore: quadrato tratteggiato rosso. */
  failing?: boolean;
  /** Variante non modificabile (fonti dei feed preferiti). */
  readOnly?: boolean;
  /**
   * Spuntata in parte (un mese con solo alcune settimane): `aria-checked="mixed"`;
   * il design non ha ancora l'icona, resta il quadrato vuoto. Un clic spunta tutto.
   */
  indeterminate?: boolean;
};

/** Checkbox con le icone del design (square-check / square / square-dashed). */
export function CheckToggle({ checked, label, onChange, failing, readOnly, indeterminate }: CheckToggleProps) {
  const icon = failing ? "squareDashed" : readOnly ? "squareCheckMuted" : checked ? "squareCheck" : "square";
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={indeterminate ? "mixed" : checked}
      aria-label={label}
      aria-readonly={readOnly || undefined}
      disabled={readOnly}
      onClick={(e) => {
        e.stopPropagation();
        onChange?.(indeterminate ? true : !checked);
      }}
      className="shrink-0 cursor-pointer rounded-xs disabled:cursor-default"
    >
      <Icon name={icon} />
    </button>
  );
}
